<template>
  <div class="card-simple">
    <img
      class="card-simple__img"
      height="100px"
      width="100%"
      :src="validarImagen(image)"
      @error="setAltImg"
    >
    <router-link :to="link" class="card-simple__name">{{ name }}</router-link>
    <p class="card-simple__text">
      {{ simpleText }}
    </p>
    <p class="card-simple__tag"> {{ tagText }} </p>
    <router-link :to="link" class="card-simple__action">{{ actionText }}</router-link>
  </div>
</template>

<script>

  import bannerImg from '../../assets/banner.jpg'
  import notImg from '@/assets/not-image.png'

  export default {
    name: 'VCardSimpleTorneo',
    props: {
      image: String,
      name: String,
      simpleText: String,
      tagText: String,
      actionText: String,
      link: Object
    },
    methods: {
      setAltImg(event) { 
        event.target.src = notImg
      },
      validarImagen: function (imagen) {
        if (imagen) {
          return imagen
        } else {
          return bannerImg
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .card-simple {
    display: block;
    background: $color-8;
    margin-bottom: 10px;
    margin-left: 5px;
    margin-right: 5px;
    padding: 10px;
    border-radius: 5px;
    &__img {
      display: block;
      width: 100%;
      height: 100px;
      border-radius: 5px;
      @include desde($large) {
        margin-bottom: 10px;
      }
    }
    &__name {
      display: flex;
      align-items: center;
      margin-left: 5px;
      margin-right: 5px;
      font-family: $ff-2;
      font-weight: bold;
      text-decoration: none;
      color: $color-1;
      height: 45px;
      overflow: hidden;
      font-size: 13px;
      &:hover {
        opacity: 0.6;
      }
      @include desde($extra-large) {
        font-size: 15px;
      }
    }
    &__text {
      margin-left: 5px;
      margin-right: 5px;
      font-size: 14px;
      color: $color-9;
      font-family: $ff-3;
      height: 20px;
    }
    &__tag {
      color: $color-2;
      font-weight: bold;
      font-family: $ff-5;
      font-size: 14px;
      text-transform: capitalize;
      margin-left: 5px;
      margin-right: 5px;
      margin-bottom: 1em;
    }
    &__action {
      display: block;
      text-align: center;
      width: 100%;
      background: $color-3;
      color: $color-white;
      font-family: $ff-2;
      text-decoration: none;
      font-size: 14px;
      padding-top: 5px;
      padding-bottom: 3px;
      border-radius: 5px;
      &:hover {
        opacity: 0.6;
      }
    }
  }
</style>